var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7077 9.34727L25.6514 7.29102L17.4993 15.4431L9.34727 7.29102L7.29102 9.34727L15.4431 17.4993L7.29102 25.6514L9.34727 27.7077L17.4993 19.5556L25.6514 27.7077L27.7077 25.6514L19.5556 17.4993L27.7077 9.34727Z",
    fill: "#2E7D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7077 9.34727L25.6514 7.29102L17.4993 15.4431L9.34727 7.29102L7.29102 9.34727L15.4431 17.4993L7.29102 25.6514L9.34727 27.7077L17.4993 19.5556L25.6514 27.7077L27.7077 25.6514L19.5556 17.4993L27.7077 9.34727Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFilled);
export default __webpack_public_path__ + "static/media/close_filled.1187e229307d9ee19c19961a6fc6bf78.svg";
export { ForwardRef as ReactComponent };